<template>
    <div>
        <div class="row">
            <div class="col-12" v-if="activity_type === 'sw'">
                <button @click="ScanNFC" class="assign-group-btn with-bottom-text" :disabled="activity_type === 'tc'">
                    {{ (action == 'add') ? 'Scan NFC' : 'Scan NFC' }}
                    <span v-if="activity_type === 'sw' && scanButtonisClick">Scanning members...</span>
                </button>
            </div>
            <div class="col-12" v-if="activity_type === 'tc'">
                <button @click="ScanNFC" class="assign-group-btn with-bottom-text" :disabled="activity_type === 'sw'">
                    {{ (action == 'add') ? 'Scan NFC' : 'Scan NFC' }}
                    <span v-if="activity_type === 'tc' && scanButtonisClick">Scanning members...</span>
                </button>
            </div>
            <div class="col-12">
                <div v-if="app_config == 'local' || app_config == 'staging'" class="dummy-nfc">
                    <label for="">Dummy NFC Code</label>
                    <input type="text" v-model="dummyNFC">
                    <button @click="submitDummyNFC">Submit</button>
                </div>
            </div>
        </div>

        <div class="group-section">
            <h2>Group {{ group_padded }}</h2>

            <div class="group-assign-wrap">
                <table class="group-assign-table" cellpadding="0" cellspacing="0">
                    <tr v-for="(session, index) in groupMember" :key="index">
                        <td><strong>{{ index + 1 }}</strong></td>
                        <td><strong class="name">{{ generateName(session.customer) }}</strong></td>
                        <td><span class="session">Session # {{ session.fourDigitNumber }}</span></td>
                        <td><span class="cs-number">Customer #:  {{ session.customer.customer_number }}</span></td>
                        <td><a href="javascript: void(0);" @click="removeFromGroup(index)" class="remove"></a></td>
                    </tr>
                </table>
            </div>

            <div class="group-assign-wrap camera">
                <table v-if="groupCamera.length" class="group-assign-table" cellpadding="0" cellspacing="0">
                    <tr v-for="(camera, index) in groupCamera" :key="index">
                        <td><span class="camera"></span></td>
                        <td><strong class="name">{{ camera.label }}</strong></td>
                        <td><span class="session">ID # {{ camera.paddedId }}</span></td>
                        <td><a href="javascript: void(0);" @click="removeFromCamera(index)" class="remove"></a></td>
                    </tr>
                </table>
            </div>

            <div v-if="groupErrorMessage.length" class="group-error-message">
                <ul>
                    <li v-for="(message, index) in groupErrorMessage" :key="index" :class="message.color">{{ message.message }}</li>
                </ul>
            </div>
        </div>

        <div class="actions group">
            <div class="d-flex align-items-center">
                <button @click="submiChanges" type="submit" name="save" class="submit" :disabled="submitDisabled">Save Changes</button> 
                <a href="javascript:void(0)" @click="resetGroupAssign({'action': 'edit', 'activity_type': activity_type.toUpperCase()})" class="cancel">Cancel</a>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    data() {
        return {
            dummyNFC: "",
            macAddress: "",
            submitDisabled: true,
            scanButtonisClick: false,
        }
    },
    props: [
        'activity_type',
        'app_config',
        'group',
        'group_padded',
        'action',
        'session',
        'camera'
    ],
    computed: {
        ...mapState([
            'groupErrorMessage',
            'groupMember',
            'groupCamera',
            ]),
    },
    methods: {
        ...mapActions([
            'beep', 
            'assignNFCToActivity', 
            'removeMember',
            'removeCamera',
            'resetGroupAssign',
            'submitGroupAssign',
            'initializeGroupMemberAndCamera'
            ]),
        generateName(customer) {
            if(!customer.firstname && !customer.lastname) {
                return customer.chinese_name;
            }
            
            return customer.firstname + " " + customer.lastname;
        },
        async removeFromGroup(index) {
            await this.removeMember({
                action: this.action,
                index: index
            });
            this.submitDisabled = false
        },
        async removeFromCamera(index) {
            await this.removeCamera({
                action: this.action,
                index: index
            });
            this.submitDisabled = false
        },
        async submiChanges() {
            this.$swal({
                title: 'Saving changes',
                html: '',
                icon: 'success',
                allowOutsideClick: false,
                didOpen: () => {
                    this.$swal.showLoading()
                }
            });
            await this.submitGroupAssign({
                action: this.action,
                activity_type: this.activity_type,
                group: this.group
            });
        },
        async ScanNFC() {
            try {
                this.scanButtonisClick = true;
                
                if(typeof FullyKiosk != "undefined") {
                    this.macAddress = fully.getMacAddress();
                    fully.nfcScanStart();
                } else {
                    const ndef = new NDEFReader();
                    await ndef.scan();

                    ndef.addEventListener("readingerror", () => {
                        this.$swal({
                            title: 'Error!',
                            html: '',
                            icon: 'error'
                        });

                    });

                    ndef.addEventListener("reading", async ({ serialNumber }) => {
                        this.beep();
                        await this.assignNFCToActivity({
                            serialNumber: serialNumber, 
                            macAddress: this.macAddress,
                            activityType: this.activity_type
                        });
                    });
                }
            } catch (error) {
                this.$swal({
                    title: 'Error!',
                    html: error + ". Please contact system administrator.",
                    icon: 'error'
                });

            }
        },
        async kioskNFCScan({detail}) {
            this.beep();
            fully.nfcScanStop();
            await this.assignNFCToActivity({
                serialNumber: detail.serialNumber, 
                macAddress: this.macAddress,
                activityType: this.activity_type
            });

            this.submitDisabled = false
            fully.nfcScanStart();
        },
        async submitDummyNFC() {
            this.beep();
            await this.assignNFCToActivity({
                serialNumber: this.dummyNFC, 
                macAddress: this.macAddress,
                activityType: this.activity_type
            });
            this.dummyNFC = "";
            this.submitDisabled = false
        },
    },
    async mounted() {
        
        await this.initializeGroupMemberAndCamera({
            group_member: JSON.parse(this.session),
            group_camera: JSON.parse(this.camera)
        });
        
        window.addEventListener('nfc_serial_to_vue_jump_deck_group_assign', this.kioskNFCScan)

    },
    created() {
        
    },
    destroyed() {
        window.removeEventListener('nfc_serial_to_vue_jump_deck_group_assign', this.kioskNFCScan, false);
    }
}
</script>
